import types from '../risks/types';

const defaultState = {
  isChemRiskLoading: false,
  isEnvRiskLoading: false
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case types.CALCULATE_CHEM_RISK_LEVEL:
      return { ...state, isChemRiskLoading: true };
    case types.CALCULATE_CHEM_RISK_LEVEL_SUCCESS:
      return { ...state, chemRiskLevelResultDto: data, isChemRiskLoading: false };
    case types.CALCULATE_CHEM_RISK_LEVEL_FAILURE:
      return { ...state, isChemRiskLoading: false };
    case types.CALCULATE_ENV_RISK:
      return { ...state, isEnvRiskLoading: true };
    case types.CALCULATE_ENV_RISK_SUCCESS:
      return { ...state, envRiskResultDto: data, isEnvRiskLoading: false };
    case types.CALCULATE_ENV_RISK_FAILURE:
      return { ...state, isEnvRiskLoading: false };
    case types.CLEAR_ENV_RISK_RESULT_DTO:
      return { ...state, envRiskResultDto: null };
    case types.CLEAR_CHEM_RISK_RESULT_DTO:
      return { ...state, chemRiskLevelResultDto: null };

    default:
      return state;
  }
};
